// extracted by mini-css-extract-plugin
module.exports = {"container":"Commitments_container__HDZOF","section":"Commitments_section__XOhmM","article":"Commitments_article__J0wOe"};